import type { TFunction } from 'i18next';

/**
 * Resolves the localized payment method label for a raw provider value.
 *
 * Uses the `paymentHistory:paymentMethods.*` namespace (e.g. STRIPE → "Tarjeta",
 * FINTOC → "SPEI"). The incoming provider is normalized to uppercase so the
 * lookup is resilient to casing drift from the backend. Unknown or empty
 * providers fall back to the original value (then "-" via displayPaymentValue).
 *
 * A card shows its last four digits instead of the generic label when the API sent them.
 *
 * @param method - Raw payment provider value from the API
 * @param detail - Last four digits of the card, empty when the API has none
 * @param t - Translator bound to the `paymentHistory` namespace
 * @returns Translated label, or the original value when not mapped
 */
export const getPaymentMethodLabel = (method: string, detail: string, t: TFunction): string => {
  if (!method) return '';
  const normalized = method.toUpperCase();
  if (normalized === 'CARD' && detail) {
    return t('paymentMethods.cardMask', { last4: detail });
  }
  return t(`paymentMethods.${normalized}`, { defaultValue: method });
};
